import React from 'react';

import PropTypes from 'prop-types';

import { ThemedSwitch } from 'components/ThemedSwitch/ThemedSwitch';

export const SubscribeBoxSwitch = ({ setSubscriptionStatus, loading, error, data }) => {
  if (loading) return null;
  if (error) return <div>Es ist ein Fehler aufgetreten</div>;
  if (!data) return null;
  return (
    <div>
      <div>Dann passen Sie Ihre Einstellungen an:</div>
      <div className="subscribe-box__toggle-wrapper">
        <div>Nein</div>
        <div>
          <ThemedSwitch
            checked={data.userStatus.subscription === 'SUBSCRIBED'}
            onChange={(e) => {
              setSubscriptionStatus({ variables: { status: e.target.checked } });
            }}
          />
        </div>
        <div>Ja</div>
      </div>
    </div>
  );
};

SubscribeBoxSwitch.propTypes = {
  setSubscriptionStatus: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  data: PropTypes.object,
};

SubscribeBoxSwitch.defaultProps = {
  error: null,
  data: null,
};
